import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/ptdProcess';

const initialState = fromJS({
  stateCodes: { data: [], state: null },
  unmappedStateCodes: [],
  clientMappings: { data: [], state: null },
  suLandTypes: { data: [], state: null },
  unmappedSULandTypes: [],
  landTypeMappings: { data: [], state: null },
  exemptions: { data: [], state: null },
  unmappedExemptions: [],
  exemptionMappings: { data: [], state: null },
  pvsTaxRateSubmissions: { data: [], state: null },
  backTotalsPtd: {},
});

const MineralImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_BACK_TOTALS_PTD: {
      return state.set('backTotalsPtd', fromJS(action.data));
    }
    case actions.FETCH_PTD_STATE_CODES[START]: {
      return state.setIn(['stateCodes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PTD_STATE_CODES[SUCCESS]: {
      return state
        .setIn(['stateCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['stateCodes', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PTD_STATE_CODES[ERROR]: {
      return state.setIn(['stateCodes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_PTD_UNMAPPED_STATE_CODES[SUCCESS]: {
      return state.setIn(
        ['unmappedStateCodes'],
        fromJS(action.data ? action.data.results : []),
      );
    }

    case actions.FETCH_CLIENT_MAPPINGS[START]: {
      return state.setIn(['clientMappings', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CLIENT_MAPPINGS[SUCCESS]: {
      return state
        .setIn(['clientMappings', 'state'], fetchingState.LOADED)
        .setIn(
          ['clientMappings', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_CLIENT_MAPPINGS[ERROR]: {
      return state.setIn(['clientMappings', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PTD_SU_LAND_TYPES[START]: {
      return state.setIn(['suLandTypes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PTD_SU_LAND_TYPES[SUCCESS]: {
      return state
        .setIn(['suLandTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['suLandTypes', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PTD_SU_LAND_TYPES[ERROR]: {
      return state.setIn(['suLandTypes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_PTD_UNMAPPED_SU_LAND_TYPES[SUCCESS]: {
      return state.setIn(
        ['unmappedSULandTypes'],
        fromJS(action.data ? action.data.results : []),
      );
    }

    case actions.FETCH_PTD_LAND_TYPES_MAPPINGS[START]: {
      return state.setIn(['landTypeMappings', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PTD_LAND_TYPES_MAPPINGS[SUCCESS]: {
      return state
        .setIn(['landTypeMappings', 'state'], fetchingState.LOADED)
        .setIn(
          ['landTypeMappings', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PTD_LAND_TYPES_MAPPINGS[ERROR]: {
      return state.setIn(['landTypeMappings', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PTD_EXEMPTIONS[START]: {
      return state.setIn(['exemptions', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PTD_EXEMPTIONS[SUCCESS]: {
      return state
        .setIn(['exemptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['exemptions', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PTD_EXEMPTIONS[ERROR]: {
      return state.setIn(['suLandTypes', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_PTD_UNMAPPED_EXEMPTIONS[SUCCESS]: {
      return state.setIn(
        ['unmappedExemptions'],
        fromJS(action.data ? action.data.results : []),
      );
    }

    case actions.FETCH_PTD_EXEMPTIONS_MAPPINGS[START]: {
      return state.setIn(
        ['exemptionMappings', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_PTD_EXEMPTIONS_MAPPINGS[SUCCESS]: {
      return state
        .setIn(['exemptionMappings', 'state'], fetchingState.LOADED)
        .setIn(
          ['exemptionMappings', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PTD_EXEMPTIONS_MAPPINGS[ERROR]: {
      return state.setIn(['exemptionMappings', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PVS_TAX_RATE_SUBMISSIONS[START]: {
      return state.setIn(
        ['pvsTaxRateSubmissions', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_PVS_TAX_RATE_SUBMISSIONS[SUCCESS]: {
      return state
        .setIn(['pvsTaxRateSubmissions', 'state'], fetchingState.LOADED)
        .setIn(
          ['pvsTaxRateSubmissions', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PVS_TAX_RATE_SUBMISSIONS[ERROR]: {
      return state.setIn(
        ['pvsTaxRateSubmissions', 'state'],
        fetchingState.ERROR,
      );
    }

    default: {
      return state;
    }
  }
};

export default MineralImportReducer;
